import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Admin side: Tailwind class merger (kept for backward compatibility).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Frontend side: joins CSS module class names, filtering out falsy values.
 */
export function cx(...classes: Array<string | undefined | null | false>): string {
  return classes.filter(Boolean).join(' ')
}

export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`
}

const LOCALE_MAP: Record<string, string> = {
  it: 'it-IT',
  en: 'en-GB',
}

export function formatDate(dateStr: string | null, locale?: string): string {
  if (!dateStr) return '\u2014'
  const resolvedLocale = LOCALE_MAP[locale ?? 'it'] ?? 'it-IT'
  return new Date(dateStr).toLocaleDateString(resolvedLocale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}

const WORDS_PER_MINUTE = 200

export function readingMinutes(html: string | null): number {
  if (!html) return 1
  const text = html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
  const words = text.split(' ').filter(Boolean).length
  return Math.max(1, Math.round(words / WORDS_PER_MINUTE))
}
